// src/components/DevicePanel/Map/MarkerManager/index.tsx

import React, { memo } from "react";
import { Marker, Tooltip } from "react-leaflet";
import { Icon } from "leaflet";
import MapIconPin from "../../../assets/icons/MapIconPin.svg";
import ArchiveBoxIcon from "@heroicons/react/24/outline/ArchiveBoxIcon";
import { ReactComponent as MosquitoIconSvg } from "../../../assets/icons/MosquitoVector.svg";
import "./index.css";
import { Typography, Badge } from "antd";
import { MarkerData } from "../../../types/components/map";

const { Text } = Typography;

const DEFAULT_TRAP_ICON = new Icon({
  iconUrl: MapIconPin,
  iconAnchor: [15, 40],
  className: "w-10 h-10 translate-y-[20px] z-1000",
});

const TrapMarker = memo(({ marker }: { marker: MarkerData }) => {
  return (
    <Marker
      position={marker.position}
      zIndexOffset={700}
      icon={DEFAULT_TRAP_ICON}
    >
      <Tooltip
        key={`${marker?.warning}`}
        permanent
        className={`map-marker ${marker?.warning ? "warning" : ""}`}
        direction={"auto"}
      >
        <div className="px-4 py-2 min-w-48">
          <Text className="marker-display-name">{marker.id}</Text>
          <></>
          {marker.maintainCount ? (
            <Badge count={marker.maintainCount} offset={[0, 0]} color="#f97316">
              <ArchiveBoxIcon
                key={`trap-icon`}
                className={`w-6 h-6 trapIcon warning`}
              />
            </Badge>
          ) : (
            ""
          )}
          {marker.detectionsCount ? (
            <Badge count={marker.detectionsCount} color="#f97316">
              <MosquitoIconSvg
                width={24}
                height={24}
                className="trapIcon"
                fill="#F97316"
              />
            </Badge>
          ) : (
            ""
          )}
        </div>
      </Tooltip>
    </Marker>
  );
});

export default TrapMarker;
